import { useContext } from 'react'; // useEffect,

import LyocLinks from '@/components/static/LyocLinks';
import '@/style/HandModal.css';
import '@/style/UI.css';
import { ViewContext } from '@/state/contexts'; // GameContext,

const SettingsModal = ({ onClose }) => {
	const {
		backgroundEffects,
		setBackgroundEffects,
		tickerTimeoutSeconds,
		toggleTickerTimeout,
	}: any = useContext(ViewContext);

	// function navHome(e) {
	// 	e.preventDefault();
	// 	window.location.href = '/';
	// }

	function toggleBackgroundEffects() {
		setBackgroundEffects((backgroundEffects) => !backgroundEffects);
	}

	return (
		<div className="modal" onClick={onClose}>
			<div
				className="modal-content-action"
				onClick={(e) => e.stopPropagation()}
			>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<div className="actionButtonContainer">
					<button
						className="split-button"
						onClick={toggleBackgroundEffects}
					>
						<span className="left-text">🏞️ Background Effects</span>
						<span className="right-text">{backgroundEffects}</span>
					</button>
					<button
						className="split-button"
						onClick={toggleTickerTimeout}
					>
						<span className="left-text">
							Toggle Ticker Timeout{' '}
						</span>
						<span className="right-text">
							{tickerTimeoutSeconds} seconds
						</span>
					</button>

					<LyocLinks gameUI={true} />

					{/*
					<button
						className="split-button"
						onClick={(e) => navHome(e)}
					>
						<span className="left-text">🏠 Nav Home</span>
					</button>
					*/}
				</div>
			</div>
		</div>
	);
};

export default SettingsModal;
